function luhn_sum(str) {
    var sum = 0;
    var is_every_second_digit = false;
    var c,digit,i;
    var CHARCODE0='0'.charCodeAt(0);
    //remove all non digit things (spaces, dashes, dots...)
    var digitstr=str.replace(/[^0-9]/g,"");
    i = digitstr.length-1;

    while (i >= 0){
        //convert char digit to number digit
        digit=digitstr.charCodeAt(i) - CHARCODE0;
        // every second digit we have to double anc
        if (is_every_second_digit) {
            digit *= 2;
            if (digit > 9){
                digit = digit - 9;
            }
        }
        //flip alternate digit counter
        is_every_second_digit = !is_every_second_digit;
        sum += digit;
        //go to next digit (from right to left)
        i--;
    }
    return(sum);
}
/* a number that contains a Luhn check digit in the right most position
 * is valid if (luhn_sum % 10 == 0)
 */
export function validateImei(str){
    if (/(111111111111111|222222222222222|333333333333333|444444444444444|555555555555555|666666666666666|777777777777777|888888888888888|999999999999999)/.test(str)){
        return false;
    }
    if (!str.match(/[0-9][0-9]/)){ // should have 2 digits somewhere otherwise it does not make sense
        return false;
    }
    str.replace(/[^0-9]/g,"");
    var s=luhn_sum(str);
    if ((s % 10) == 0){
        return true;
    }else{
        return false;
    }
    return false;
}

